import { getReferenceId } from '@quromedical/fhir-common';
import type {
  ClaimResponseGetAllParams,
  ClaimResponseModel,
  ClaimResponseModelGetAllResponse,
  ClaimResponseModelGetResponse,
} from '@quromedical/models';
import { trpcClient } from 'trpc';

export class ClaimResponseApi {
  public async getAll(
    params: ClaimResponseGetAllParams = {},
  ): Promise<ClaimResponseModelGetAllResponse> {
    const result = await trpcClient.claimResponse.getAll.query({ ...params });

    return result;
  }

  public async reverseClaim(
    claimResponse: ClaimResponseModel,
  ): Promise<ClaimResponseModelGetResponse | undefined> {
    const claimId = getReferenceId(claimResponse.claim) || '';
    const claim = await trpcClient.claim.getById.query({ id: claimId });

    if (!claim.invoiceNumber) {
      return undefined;
    }

    const result = await trpcClient.claimResponse.reverse.mutate({
      invoiceNumber: claim.invoiceNumber,
    });

    return result;
  }
}
